// This script is dependent on a back-end route where it sends its consumerUrl to
// The back-end sends the consumerRequest to the provider with the correct headers that can not be site with this JS
// The back-end then returns the json response of the provider which this script picks back up

export default class OEmbedParser {
    constructor (el, options) {
        this.name = 'OEmbedParser';
        this.oEmbedElement = el;
        this.options = Object.assign(this.getDefaultOptions(), options);
        this.oEmbedList = require(`${this.options.oEmbedListPath}`);
        this.parseOEmbed();
    }

    getDefaultOptions() {
        return {
            oEmbedListPath: './oEmbed-provider-list.json', // needs to be compatible with https://oembed.com/providers.json
            oEmbedUrl: null, // oEmbed url to find provider for and fetch data for
            oEmbedRequestPath: null, // Required
        };
    }

    async parseOEmbed() {
        if (!this.options.oEmbedRequestPath) {
            throw new Error(`No oEmbedRequestPath is provided. Without this you can not fetch oEmbed data from the server`);
        }

        if (!this.isValidUrl(this.options.oEmbedUrl)) {
            // Don't throw error, the script needs to continue for the next oEmbed element in the dom
            console.error(`The provided url given by an oEmbed element is not valid. Url: ${this.options.oEmbedUrl}`);
        }

        const providerList = this.getProvidersFromList(this.oEmbedList);
        const provider = this.findProvider(this.options.oEmbedUrl, providerList);

        if (!provider) {
            console.error(`No oEmbed provider was found for the Url: ${this.options.oEmbedUrl}`);
        }

        const consumerUrl = this.getConsumerUrl(provider.url, this.options.oEmbedUrl);
        const requestUrl = new URL(this.options.oEmbedRequestPath);
        requestUrl.searchParams.append('url', consumerUrl);
        const jsonResponse = await this.getProviderResponse(requestUrl.href);
        this.injectHtml(jsonResponse);
        //this.oEmbedElement.remove(); // <oembed> element no longer needed
    }

    isValidUrl(url) {
        if (!url) {
            return;
        }

        let pattern = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

        if (!pattern.test(url)) {
            return;
        }

        return true;
    }

    getProvidersFromList(oEmbedList) {
        return oEmbedList.map((item) => {
            const { provider_name, provider_url, endpoints: [{ schemes = [], url }] } = item;
            const hostname = this.getHostName(url);
            const domain = hostname ? hostname.replace('www.', '') : '';
            return { provider_name, provider_url, schemes, domain, url };
        })
        .filter(item => item.domain !== '');
    }

    getHostName(url) {
        const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);

        if (match && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        }

        return null;
    };

    findProvider(url, providerList) {
        const candidates = providerList.filter((provider) => {
            const { schemes, domain } = provider;

            if (!schemes.length) {
                return url.includes(domain);
            }

            return schemes.some((scheme) => {
                const reg = new RegExp(scheme.replace(/\*/g, '(.*)'), 'i');
                return url.match(reg);
            });
        });

        return candidates.length > 0 ? candidates[0] : null;
    }

    getConsumerUrl(endpoint_url, url) {
        const baseUrl = endpoint_url.replace(/{format}/g, 'json');
        const queries = [
            'format=json',
            `url=${encodeURIComponent(url)}`,
        ];
        return `${baseUrl}?${queries.join('&')}`;
    }

    async getProviderResponse(oEmbedRequestPath) {
        const options = {
            mode: 'cors',
            method: 'GET'
        };

        return await fetch(oEmbedRequestPath, options)
            .then(response => response.json())
            .then(jsonResponse => jsonResponse);
    }

    injectHtml(jsonResponse) {
        const { html, title, type, width, height } = jsonResponse;
        const parentNode = this.oEmbedElement.parentNode;
        /*const referenceNode = this.oEmbedElement;
        let newNode = document.createElement('div');

        newNode.setAttribute('class', 'oEmbedMedia');
        newNode.setAttribute('title', title);
        type && newNode.setAttribute('data-type', type);
        width && newNode.setAttribute('width', width);
        height && newNode.setAttribute('height', height);
        newNode.innerHTML = html;

        parentNode.insertBefore(newNode, referenceNode)*/

        parentNode.setAttribute('class', 'oEmbedMedia');
        parentNode.setAttribute('title', title);
        type && parentNode.setAttribute('data-type', type);
        width && parentNode.setAttribute('width', width);
        height && parentNode.setAttribute('height', height);
        parentNode.innerHTML = html;
    }
}
